import { restApiClient } from '@/datasources';
import { CartCoupon } from '@/types/cart.types';

export const APPLY_COUPON_ROUTE = '/coupon/apply';

export async function applyCoupon(code: string): Promise<CartCoupon | null> {
  const { data } = await restApiClient.post<CartCoupon | undefined>(APPLY_COUPON_ROUTE, { code });

  return data ?? null;
}
